module.exports = __webpack_public_path__ + "static/img/5.c5b188e5.png";